<template>
    <div>
        <v-layout wrap justify-center>
      <v-flex xs9 sm10 md10 lg9>
        <v-card style="overflow: auto">
          <v-layout
            wrap
            justify-center
            pa-lg-10
            pa-sm-10
            pa-md-10
            pa-5
            px-lg-16
          >
            <v-flex xs12 sm12 md12 lg12>
              <v-layout wrap justify-center>
                <v-flex xs12 sm4 md5 lg4>
                  <span
                    style="
                      font-family: Montserrat-Bold;
                      font-size: 22px;
                      font-weight: 600;
                    "
                    >{{ fname.name }} File Register</span>
                </v-flex>

                <v-flex sm8 md7 lg8>
  <v-layout wrap justify-center>
    <!-- Search Field -->
    <v-flex xs12 sm4 md4 lg6 class="text-right">
      <v-text-field
        v-model="fileRegisterSearch"
        type="text"
        placeholder="Search"
        outlined
        dense
        hide-details="auto"
      ></v-text-field>
    </v-flex>

    <!-- Filter Button -->
    <v-flex xs12 sm3 md4 lg3 class="text-end" pt-lg-0 pt-md-0 pt-sm-0 pt-2 pl-sm-5 pl-md-0 pl-lg-0>
      <v-btn
      :small="$vuetify.breakpoint.smAndDown"
        style="background-color: rgba(0, 160, 142, 1); color: white"
        @click="sendFilterDialog = true"
      >
        <span style="color:white">Filter</span> &nbsp;
        <v-icon small style="color: white;">mdi-tune-variant</v-icon>
      </v-btn>
    </v-flex>

    <template>
  <v-flex xs12 sm5 md4 lg3 class="text-end" pt-lg-0 pt-md-0 pt-sm-0 pt-2>
    <v-menu
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        :small="$vuetify.breakpoint.smAndDown"
          v-bind="attrs"
          v-on="on"
          style="background-color: rgba(0, 160, 142, 1); color: white"
        >
          <span style="color: white">Download</span> &nbsp;
          <v-icon small style="color: white;">mdi-download</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="fileExportZip()">
          <v-list-item-title>Download ZIP</v-list-item-title>
        </v-list-item>
        <v-list-item @click="fileExportXlsx()" :disabled="selectedZipFiles.length !== 0">
          <v-list-item-title>Download XLSX</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-flex>
</template>



  </v-layout>
</v-flex>


              </v-layout>

              <v-layout wrap justify-center pt-sm-7 pt-md-5 pt-lg-7>
                <v-flex xs12 sm12 md12 lg12 v-if="files.length > 0">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>

                          <th
              class="text-left"
              style="font-family: Montserrat-Regular; font-size: 18px; font-weight: 600; color: black; padding-left: 0; padding-right: 0;"
            >
            </th>
            
                          <th
                            class="text-left"
                            style="
                              font-family: Montserrat-Regular;
                              font-size: 18px;
                              font-weight: 600;
                              color: black;
                              padding-left: 0;
                              padding-right: 0;
                            "
                             :style="{
                              fontSize:
                                $vuetify.breakpoint.name === 'xs'
                                  ? '14px'
                                  : $vuetify.breakpoint.name === 'sm'
                                  ? '18px'
                                  : $vuetify.breakpoint.name === 'md'
                                  ? '18px'
                                  : $vuetify.breakpoint.name === 'lg'
                                  ? '18px'
                                  : '18px',
                            }"
                          >
                            File Name
                          </th>
                          <th
                            class="text-left"
                            style="
                              font-family: Montserrat-Regular;
                              font-size: 18px;
                              font-weight: 600;
                              color: black;
                              padding-left: 0;
                              padding-right: 0;
                            "
                             :style="{
                              fontSize:
                                $vuetify.breakpoint.name === 'xs'
                                  ? '14px'
                                  : $vuetify.breakpoint.name === 'sm'
                                  ? '18px'
                                  : $vuetify.breakpoint.name === 'md'
                                  ? '18px'
                                  : $vuetify.breakpoint.name === 'lg'
                                  ? '18px'
                                  : '18px',
                            }"
                          >
                            Updated
                          </th>
                          <th
                            class="text-left"
                            style="
                              font-family: Montserrat-Regular;
                              font-size: 18px;
                              font-weight: 600;
                              color: black;
                              padding-left: 0;
                              padding-right: 0;
                            "
                             :style="{
                              fontSize:
                                $vuetify.breakpoint.name === 'xs'
                                  ? '14px'
                                  : $vuetify.breakpoint.name === 'sm'
                                  ? '18px'
                                  : $vuetify.breakpoint.name === 'md'
                                  ? '18px'
                                  : $vuetify.breakpoint.name === 'lg'
                                  ? '18px'
                                  : '18px',
                            }"
                          >
                            Size
                          </th>
                          <th
                            class="text-center"
                            style="
                              font-family: Montserrat-Regular;
                              font-size: 18px;
                              font-weight: 600;
                              color: black;
                              padding-left: 0;
                              padding-right: 0;
                            "
                             :style="{
                              fontSize:
                                $vuetify.breakpoint.name === 'xs'
                                  ? '14px'
                                  : $vuetify.breakpoint.name === 'sm'
                                  ? '18px'
                                  : $vuetify.breakpoint.name === 'md'
                                  ? '18px'
                                  : $vuetify.breakpoint.name === 'lg'
                                  ? '18px'
                                  : '18px',
                            }"
                          >
                            Type
                          </th>
                          <th
                            class="text-right"
                            style="
                              font-family: Montserrat-Regular;
                              font-size: 18px;
                              font-weight: 600;
                              color: black;
                              padding-left: 0;
                              padding-right: 0;
                            "
                             :style="{
                              fontSize:
                                $vuetify.breakpoint.name === 'xs'
                                  ? '14px'
                                  : $vuetify.breakpoint.name === 'sm'
                                  ? '18px'
                                  : $vuetify.breakpoint.name === 'md'
                                  ? '18px'
                                  : $vuetify.breakpoint.name === 'lg'
                                  ? '18px'
                                  : '18px',
                            }"
                          >
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in paginatedNotifications" :key="item.name">


                          <td
    class="text-left"
    style="
      width: 50px; /* Fixed width for checkbox column */
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <v-checkbox
      v-model="selectedZipFiles"
      class="pa-0 pb-4"
      :value="item._id"
      hide-details
      multiple
    ></v-checkbox>
  </td>
                          <!-- <td
  class="text-center"
  style="
    width: 50px; /* Fixed width for checkbox column */
    padding: 8px; /* Same padding as other columns */
    text-align: center; /* Center the content */
    vertical-align: middle; /* Aligns content vertically */
  "
>
  <v-checkbox
    v-model="selectedZipFiles"
    class="pa-0 pb-4"
    :value="item._id"
    hide-details
    multiple
  ></v-checkbox>
</td> -->


  
  <!-- <td
    v-if="item.category === 'PDF'"
    class="text-left"
    style="
      font-family: Lato-Regular;
      font-size: 14px;
      font-weight: 500;
      color: black;
      cursor: pointer;
      padding: 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100% - 50px); 
    "
    @click="navigateToSelectedFile(item._id, item.name)"
  >
    <div style="display: flex; align-items: center;">
      <v-icon color="red" large>mdi-file-pdf-box</v-icon>
      <span style="margin-left: 8px;">
        {{ truncateText(item.fileOriginalName, 40) }}
      </span>
    </div>
    <small style="color: gray; display: block; margin-top: 4px;">
      Project: {{ item.projectName }} | Department: {{ item.departmentName }}
    </small>
  </td>

 
  <td
    v-if="item.category === 'DXF'"
    class="text-left"
    style="
      font-family: Lato-Regular;
      font-size: 14px;
      font-weight: 500;
      color: black;
      cursor: pointer;
      padding: 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100% - 50px); 
    "
    @click="navigateToSelectedFile(item._id, item.name)"
  >
    <div style="display: flex; align-items: center;">
      <div
        style="
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 28px;
          height: 28px;
          background-color: black;
          color: white;
          font-weight: bold;
          font-size: 11px;
          border-radius: 4px;
          margin-right: 8px;
        "
      >
        DXF
      </div>
      <span>{{ item.fileOriginalName }}</span>
    </div>
    <small style="color: gray; display: block; margin-top: 4px;">
      Project: {{ item.projectName }} | Department: {{ item.departmentName }}
    </small>
  </td> -->

                            <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'PDF'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                            <span>
                              <v-icon color="red" large>
                                mdi-file-pdf-box
                              </v-icon>
                              &nbsp; {{ truncateText(item.fileOriginalName, 40) }}
                            </span>
                          </td>

                            <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'DXF'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                          <span style="display: flex; align-items: center;">&nbsp;
                              <div
                                style="
                                  display: inline-flex;
                                  justify-content: center;
                                  align-items: center;
                                  width: 28px;
                                  height: 28px;
                                  background-color: black;
                                  color: white;
                                  font-weight: bold;
                                  font-size: 11px;
                                  border-radius: 4px;
                                  margin-right: 8px;
                                  margin-left: 1px;
                                "
                              >
                              DXF
                              </div>&nbsp;
                              {{ item.fileOriginalName }}
                            </span>
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'DWG'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                          <span style="display: flex; align-items: center;">&nbsp;
                              <div
                                style="
                                  display: inline-flex;
                                  justify-content: center;
                                  align-items: center;
                                  width: 28px;
                                  height: 28px;
                                  background-color: black;
                                  color: white;
                                  font-weight: bold;
                                  font-size: 11px;
                                  border-radius: 4px;
                                  margin-right: 8px;
                                  margin-left: 1px;
                                "
                              >
                                DWG
                              </div>&nbsp;
                              {{ item.fileOriginalName }}
                            </span>
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'SKP'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                          <span style="display: flex; align-items: center;">&nbsp;
                              <div
                                style="
                                  display: inline-flex;
                                  justify-content: center;
                                  align-items: center;
                                  width: 28px;
                                  height: 28px;
                                  background-color: black;
                                  color: white;
                                  font-weight: bold;
                                  font-size: 11px;
                                  border-radius: 4px;
                                  margin-right: 8px;
                                  margin-left: 1px;
                                "
                              >
                                SKP
                              </div>&nbsp;
                              {{ item.fileOriginalName }}
                            </span>
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'REVIT'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                          <span style="display: flex; align-items: center;">&nbsp;
                              <div
                                style="
                                  display: inline-flex;
                                  justify-content: center;
                                  align-items: center;
                                  width: 28px;
                                  height: 28px;
                                  background-color: black;
                                  color: white;
                                  font-weight: bold;
                                  font-size: 11px;
                                  border-radius: 4px;
                                  margin-right: 8px;
                                  margin-left: 1px;
                                "
                              >
                                RVT
                              </div>&nbsp;
                              {{ item.fileOriginalName }}
                            </span>
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === '3DS'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                          <span style="display: flex; align-items: center;">&nbsp;
                              <div
                                style="
                                  display: inline-flex;
                                  justify-content: center;
                                  align-items: center;
                                  width: 28px;
                                  height: 28px;
                                  background-color: black;
                                  color: white;
                                  font-weight: bold;
                                  font-size: 11px;
                                  border-radius: 4px;
                                  margin-right: 8px;
                                  margin-left: 1px;
                                "
                              >
                                3DS
                              </div>&nbsp;
                              {{ item.fileOriginalName }}
                            </span>
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'PDS'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                          <span style="display: flex; align-items: center;">&nbsp;
                              <div
                                style="
                                  display: inline-flex;
                                  justify-content: center;
                                  align-items: center;
                                  width: 28px;
                                  height: 28px;
                                  background-color: black;
                                  color: white;
                                  font-weight: bold;
                                  font-size: 11px;
                                  border-radius: 4px;
                                  margin-right: 8px;
                                  margin-left: 1px;
                                "
                              >
                                PDS
                              </div>&nbsp;
                              {{ item.fileOriginalName }}
                            </span>
                          </td>



                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'DOC'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                            <span>
                              <v-icon color="pink" large
                                >mdi-alpha-d-box</v-icon
                              >
                              &nbsp; {{ truncateText(item.fileOriginalName, 40) }}
                            </span>
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'JPG/JPEG' || item.category === 'JPG'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                            <span>
                              <v-icon color="blue" large>
                                mdi-file-jpg-box
                              </v-icon>
                              &nbsp; {{ truncateText(item.fileOriginalName, 40) }}
                            </span>
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'JPEG'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                            <span>
                              <v-icon color="blue" large>
                                mdi-file-jpg-box
                              </v-icon>
                              &nbsp; {{ truncateText(item.fileOriginalName, 40) }}
                            </span>
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'EXCEL'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                            <span>
                              <v-icon color="green" large>
                                mdi-file-excel-box
                              </v-icon>
                              &nbsp; {{ truncateText(item.fileOriginalName, 40) }}
                            </span>
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'PPT'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                            <span>
                              <v-icon color="orange" large>
                                mdi-file-powerpoint-box
                              </v-icon>
                              &nbsp; {{ truncateText(item.fileOriginalName, 40) }}
                            </span>
                          </td>
                          
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              cursor: pointer;
                              padding-left: 0;
                              padding-right: 0;
                            "
                            v-if="item.category === 'PNG'"
                            @click="navigateToSelectedFile(item._id,item.name)"
                          >
                            <span>
                              <v-icon color="#FFDF00" large>
                                mdi-file-png-box
                              </v-icon>
                              &nbsp; {{ truncateText(item.fileOriginalName, 40) }}
                            </span>
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              padding-left: 0;
                              padding-right: 0;
                            "
                          >
                            {{ formatDateTime(item.update_date) }}
                          </td>
                          <td
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              padding-left: 0;
                              padding-right: 0;
                            "
                          >
                            {{ formatSize(item.fileSize) }} MB
                          </td>
                          <td
                            class="text-center"
                            style="
                              font-family: Lato-Regular;
                              font-size: 14px;
                              font-weight: 500;
                              color: black;
                              padding-left: 0;
                              padding-right: 0;
                            "
                          >
                            {{ item.category }}
                          </td>
                          <td
                          class="text-end"
                          style="
                            font-family: Lato-Regular;
                            font-size: 14px;
                            font-weight: 500;
                            color: black;
                            padding-left: 16px;
                            padding-right: 0;
                            "
>
<v-layout wrap justify-end>
  <v-flex lg4 v-if="item.status === 'Obsolete'" class="text-right status-flex">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-img
          src="../assets/images/obsolete4px.png"
          width="14px"
          height="14px"
          v-on="on"
        ></v-img>
      </template>
      <span class="small-tooltip">Obsolete Status</span>
    </v-tooltip>
  </v-flex>
  <v-flex lg4 v-if="item.status === 'Current'" class="text-right status-flex">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-img
          src="../assets/images/current4px.png"
          width="11px"
          height="15px"
          v-on="on"
        ></v-img>
      </template>
      <span class="small-tooltip">Current Status</span>
    </v-tooltip>
  </v-flex>
  <v-flex lg4 v-if="item.status === 'Updating'" class="text-right status-flex">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-img
          src="../assets//images/updating4px.png"
          width="14px"
          height="14px"
          v-on="on"
        ></v-img>
      </template>
      <span class="small-tooltip">Updating Status</span>
    </v-tooltip>
  </v-flex>
  <v-flex lg4 v-if="item.approvalStatus === 'Approved'" class="text-right status-flex">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-img
          src="../assets/images/approved4px.png"
          width="15px"
          height="15px"
          v-on="on"
        ></v-img>
      </template>
      <span class="small-tooltip">Approved</span>
    </v-tooltip>  
  </v-flex>

  <v-flex lg4 v-if="item.approvalStatus === 'Revise'" class="text-right status-flex">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-img
          src="../assets/images/Vector.png"
          width="15px"
          height="15px"
          v-on="on"
        ></v-img>
      </template>
      <span class="small-tooltip">Revise</span>
    </v-tooltip>  
  </v-flex>


  <v-flex lg4 v-if="item.approvalStatus === 'To be approved'" class="text-right status-flex">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-img
          src="../assets/images/tobeapproved4px.png"
          width="15px"
          height="15px"
          v-on="on"
        ></v-img>
      </template>
      <span class="small-tooltip">To be Approved</span>
    </v-tooltip>
  </v-flex>
</v-layout>

</td>

                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-flex lg12 pb-2 class="text-center" v-if="files.length > itemsPerPage">
  <v-btn 
    plain 
    @click="prevPage" 
    :disabled="currentPage === 1"
  >
    <v-icon style="font-size: 40px;">mdi-page-first</v-icon>
  </v-btn>

  <v-btn 
    plain 
    @click="nextPage" 
    :disabled="currentPage === totalPages"
  >
    <v-icon style="font-size: 40px;">mdi-page-last</v-icon>
  </v-btn>
</v-flex>


                </v-flex>

                             

                <v-flex xs9 sm10 md10 lg9 v-else>
              <v-layout wrap pt-lg-7>
                <v-flex xs12 sm12 md12 lg12>
                  <v-layout wrap justify-center>
                        <v-flex lg3>
                          <v-img src="../assets/images/noworklist.png" ></v-img>
                        </v-flex>
                        <v-flex lg12 pt-5 class="text-center">
                          <span>No Files !!</span>
                        </v-flex>
                      </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

    
    </v-layout>

    <v-dialog v-model="sendFilterDialog" width="500px" style="height: 400px;">
          <v-card >
            <v-layout wrap justify-center>
              <v-flex  xs12 sm12 md12 lg12 pa-8 >
                <v-layout wrap justify-center>
                  <v-flex xs11 sm11 md11 lg11 pb-3>
                    <span
                      style="
                        font-family: Montserrat-Regular;
                        font-size: 24px;
                        font-weight: 700;
                      "
                      :style="{
                              fontSize:
                                $vuetify.breakpoint.name === 'xs'
                                  ? '20px'
                                  : $vuetify.breakpoint.name === 'sm'
                                  ? '24px'
                                  : $vuetify.breakpoint.name === 'md'
                                  ? '24px'
                                  : $vuetify.breakpoint.name === 'lg'
                                  ? '24px'
                                  : '24px',
                            }"
                      >File Register Filter
                    </span>
                  </v-flex>
                  <v-flex xs1 sm1 md1 lg1>
                    <v-btn icon @click="sendFilterDialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-flex>
                  </v-layout>

                   <v-divider class="my-1"></v-divider> <!-- Add margin to ensure visibility -->

                  <v-layout wrap justify-center>
                    <v-flex xs12 sm6 md6 lg6>
                      <v-layout wrap justify-center>
                        <v-flex xs12 sm12 md12 lg12 pb-3 style="cursor: pointer" :class="{ 'selected-flex': selectedItem === 'projects' }" @click="projectOut()">
                          <span style="font-family: Lato-Regular;font-size: 16px;font-weight: 500;">Projects</span>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12 pb-3 style="cursor: pointer" :class="{ 'selected-flex': selectedItem === 'departments' }" @click="departmentOut()">
                          <span style="font-family: Lato-Regular;font-size: 16px;font-weight: 500;">Departments</span>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12 pb-3 style="cursor: pointer" :class="{ 'selected-flex': selectedItem === 'date' }" @click="dateOut()">
                          <span style="font-family: Lato-Regular;font-size: 16px;font-weight: 500;">Date</span>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12 pb-3 style="cursor: pointer" :class="{ 'selected-flex': selectedItem === 'status' }"  @click="statusOut()">
                          <span style="font-family: Lato-Regular;font-size: 16px;font-weight: 500;">Status</span>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12 pb-3 style="cursor: pointer" :class="{ 'selected-flex': selectedItem === 'status' }"  @click="ApprovalstatusOut()">
                          <span style="font-family: Lato-Regular;font-size: 16px;font-weight: 500;">Approval Status</span>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12 pb-3 style="cursor: pointer" :class="{ 'selected-flex': selectedItem === 'status' }"  @click="issuedForOut()">
                          <span style="font-family: Lato-Regular;font-size: 16px;font-weight: 500;">Issued for</span>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12 pb-3 style="cursor: pointer" :class="{ 'selected-flex': selectedItem === 'status' }"  @click="docTypeOut()">
                          <span style="font-family: Lato-Regular;font-size: 16px;font-weight: 500;">Category</span>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12 pb-3 style="cursor: pointer" :class="{ 'selected-flex': selectedItem === 'status' }"  @click="docRefOut()">
                          <span style="font-family: Lato-Regular;font-size: 16px;font-weight: 500;">Category Reference </span>
                        </v-flex>

                        <!-- <v-flex lg12 pb-3 style="cursor: pointer" :class="{ 'selected-flex': selectedItem === 'tags' }" @click="tagsOut()">
                          <span style="font-family: Lato-Regular;font-size: 16px;font-weight: 500;">Tags</span>
                        </v-flex> -->
                      </v-layout>

                    </v-flex>

                    <v-divider class="hidden-xs-only" vertical></v-divider>
                    <v-flex xs12 pb-2 class="hidden-sm-and-up">
                      <v-divider></v-divider>
                    </v-flex>


                    <v-flex xs12 sm6 md6 lg6 pl-5 class="scrollable-container" style="height: 250px;">
                      <v-layout wrap justify-center>
                        <!-- <v-flex lg12 pb-3>
                          <v-layout> -->
                            <v-flex lg12 pb-3 v-for="(item, index) in sendFilterProject" :key="index" v-if="projectOptions && sendFilterProject.length > 0">
                              <v-layout wrap justify-center>
                                <v-flex lg12 v-if="item.name">
                                  <v-radio-group class="custom-radio-group" v-model="sendFilterprojectRadio"  row hide-details="auto">
                                    <v-radio :value="item._id" class="custom-radio" @click="departmentsforSendFilter(item._id)" >
                                      <template v-slot:label>
                                        <span style="font-family: Lato-Regular; font-size: 15px; font-weight: 500; color: #121212;">{{item.name}}</span>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex lg12 pb-3 v-if="projectOptions" py-16 align-self-center class="text-center">
                              <span style="font-family: Lato-Regular; font-size: 14px; font-weight: 500;">No projects found</span>
                            </v-flex>

                            <v-flex lg12 v-if="departmentOptions && sendFilterdepartments.length > 0">
                              <v-layout wrap justify-center>
                                <v-flex lg12 pb-3 v-for="(item, index) in sendFilterdepartments" :key="index">
                                  <v-layout wrap justify-center>
                                    <v-flex lg12 v-if="item.name">
                                  <v-radio-group class="custom-radio-group" v-model="sendFilterDeptRadio" row hide-details="auto">
                                    <v-radio :value="item._id" class="custom-radio">
                                      <template v-slot:label>
                                        <span style="font-family: Lato-Regular; font-size: 16px; font-weight: 500; color: #121212;">{{item.name}}</span>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                  </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex lg12 pb-3 v-else-if="departmentOptions" py-16 align-self-center class="text-center">
                              <span style="font-family: Lato-Regular; font-size: 14px; font-weight: 500;">Please Select any Project</span>
                            </v-flex>

                            <v-flex lg12 pb-3 v-if="dateOptions">
                              <v-layout wrap justify-center>
                                <v-flex xs12 sm12 md12 lg12 pb-lg-1>
                                  <span style="">From date</span>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12>
                                  <v-menu
                                    ref="menu"
                                    v-model="sendfromDateMenu"
                                    :close-on-content-click="true"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="sendfromDate"
                                        outlined
                                        dense
                                        placeholder="Filter From Date"
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                        hide-details="auto"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="sendfromDate"
                                      no-title
                                      @input="menu = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>

                                <v-flex xs12 sm12 md12 lg12 pt-lg-2 pb-lg-1>
                                  <span style="">To date</span>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12>
                                  <v-menu
                                    ref="menu"
                                    v-model="sendtoDateMenu"
                                    :close-on-content-click="true"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="sendtoDate"
                                        outlined
                                        dense
                                        placeholder="Filter From Date"
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                        hide-details="auto"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="sendtoDate"
                                      no-title
                                      @input="menu = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex lg12 pb-3 v-for="(item, index) in statusSendFilter" :key="index" v-if="statusOptions">
                              <v-layout wrap justify-center>
                                <v-flex lg12>
                                  <v-radio-group class="custom-radio-group" v-model="sendStatusRadio"  row hide-details="auto">
                                    <v-radio :value="item" class="custom-radio">
                                      <template v-slot:label>
                                        <span style="font-family: Lato-Regular; font-size: 16px; font-weight: 500; color: #121212;">{{item}}</span>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex lg12 pb-3 v-for="(item, index) in ApprovalstatusSendFilter" :key="index" v-if="ApprovalstatusOptions">
                              <v-layout wrap justify-center>
                                <v-flex lg12>
                                  <v-radio-group class="custom-radio-group" v-model="sendApprovalStatusRadio"  row hide-details="auto">
                                    <v-radio :value="item" class="custom-radio">
                                      <template v-slot:label>
                                        <span style="font-family: Lato-Regular; font-size: 16px; font-weight: 500; color: #121212;">{{item}}</span>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex lg12 pb-3 v-for="(item, index) in issuedfor" :key="index" v-if="issuedforOptions">
                              <v-layout wrap justify-center>
                                <v-flex lg12>
                                  <v-radio-group class="custom-radio-group" v-model="sendissuedforRadio"  row hide-details="auto">
                                    <v-radio :value="item" class="custom-radio">
                                      <template v-slot:label>
                                        <span style="font-family: Lato-Regular; font-size: 16px; font-weight: 500; color: #121212;">{{item}}</span>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex lg12 pb-3 v-for="(item, index) in typeofDoc" :key="index" v-if="docTypeOptions">
    <v-layout wrap justify-center>
      <v-flex lg12>
        <v-radio-group 
          class="custom-radio-group" 
          v-model="senddocTypeRadio"  
          row 
          hide-details="auto"
          @change="updateReferences"
        >
          <v-radio :value="item" class="custom-radio">
            <template v-slot:label>
              <span style="font-family: Lato-Regular; font-size: 16px; font-weight: 500; color: #121212;">{{ item }}</span>
            </template>
          </v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
  </v-flex>

  <!-- References based on selected Document Type -->
   <v-flex lg12 v-if="docRefOptions">
    <v-layout wrap justify-center v-if="selectedRef.length > 0">
      <v-flex lg12 pb-3 v-for="(item, index) in selectedRef" :key="index">
    <v-layout wrap justify-center>
      <v-flex lg12>
        <v-radio-group 
          class="custom-radio-group" 
          v-model="senddocRefRadio"  
          row 
          hide-details="auto"
        >
          <v-radio :value="item" class="custom-radio">
            <template v-slot:label>
              <span style="font-family: Lato-Regular; font-size: 16px; font-weight: 500; color: #121212;">{{ item }}</span>
            </template>
          </v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
  </v-flex>
    </v-layout>

    <v-layout wrap justify-center v-else>
      <v-flex lg12 pb-3 py-16 align-self-center class="text-center">
        <span style="font-family: Lato-Regular; font-size: 14px; font-weight: 500;">Please Select any Category</span>
      </v-flex>
    </v-layout>
   </v-flex>

  

                            <v-flex lg12 pb-3 v-for="(item, index) in tagsSendFilter" :key="index" v-if="tagsOptions">
                              <v-layout wrap justify-center>
                                <v-flex lg12>
                                  <v-radio-group class="custom-radio-group" v-model="sendTagsRadio"  row hide-details="auto">
                                    <v-radio :value="item" class="custom-radio">
                                      <template v-slot:label>
                                        <span style="font-family: Lato-Regular; font-size: 16px; font-weight: 500; color: #121212;">{{item}}</span>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <!-- <v-flex lg11 pl-5 align-self-center>
                              <span style="font-family: Lato-Regular;font-size: 16px;font-weight: 500;">Projects</span>
                            </v-flex> -->
                          <!-- </v-layout>
                          
                        </v-flex> -->

                      </v-layout>
                    </v-flex>


                    <v-flex xs8 sm5 md5 lg5 pa-2 class="text-center">
                      <v-btn
                      block
                        style="background-color: rgba(0, 160, 142, 1)"
                        @click="clearSendRequestFilter()"
                      >
                        <span style="color: white">clear All</span>
                      </v-btn>
                    </v-flex>

                    <v-flex xs8 sm5 md5 lg5 pa-2 class="text-center">
                      <v-btn
                      block
                        style="background-color: rgba(0, 160, 142, 1)"
                        @click="sendRequests()"
                      >
                        <span style="color: white">Submit</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                
              </v-flex>
            </v-layout>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from "axios";
    import moment from "moment";

    export default {

      metaInfo: {
  title: 'File Register - Teamite | All Project Files in One Place',
  meta: [
    {
      name: 'description',
      content: 'Access and manage all your project documents in one centralized file register. Filter, review, and keep track of all files across folders with Teamite.'
    },
    {
      name: 'keywords',
      content: 'Teamite file register, project files, document listing, centralized file access, file tracking, team collaboration, document management system'
    },
    { property: 'og:title', content: 'File Register - Teamite' },
    {
      property: 'og:description',
      content: 'View and manage all uploaded documents across your projects and folders using Teamite’s comprehensive file register.'
    },
    { property: 'og:url', content: 'https://yourdomain.com/fileregister' }, // Replace with actual URL
    { property: 'og:type', content: 'website' },
    { name: 'robots', content: 'noindex, nofollow' } // Use noindex if restricted to logged-in users
  ]
},

        data() {
    return {
      noRestriction: localStorage.getItem('noRestriction') === 'true',
      listAndView: localStorage.getItem('listAndView') === 'true',
      fileUploadLimit: localStorage.getItem('fileUploadLimit') === 'true',
      // uploadLimit: parseInt(localStorage.getItem('uploadLimit'), 10), 

      uploadLimit: parseInt(localStorage.getItem('uploadLimit'), 10),

      // uploadLimit: 1,
   

      selectedOptions: {},
      showSnackBar: false,
      msg: "",
      name: "",
      selectedTab: "",
      optiondialouge: false,
      project: [],
      category: "",
      categoryChip: [],
      acceptedFileType:"",
      viewers: "",
      comments: "",
      deptid: "",
      folderIds: [],
      folder: "",
      fname:'',
      docdetails: [],
      folders: [],
      items: [{ title: "Edit" }, { title: "Delete" }],
      departmentId: null,
      id: this.$route.query.depId,
      files: [],
      dropdownfolders: [],
      selectedFiles: [],
      selectedFile:'',
      Description: "",
      fileUpload: "",
      projectname: "",
      projectName: "",
      foldername: "",
      search: "",
      // handleSearch: "",
      comment: "",
      newpostDialog: false,
      teammembers: false,
      // recentCard: true,
      // detailedCard: false,
      selectedOption: "",
      sectionname: "",
      filtermodel: null,
      categoryList: [],
      members: [],
      approvalcheck: false,
      email: "",
      approvalMemberIds: [],
      uploadItems: [
        { fileName: '', description: '', file: null, fileType: '', issuedFor: '', documentType: '', documentReference: '', documentNumber:'', revision:'', zone:'', },
      ],
      // formData: new FormData(),
      // file: [],
      commentsType: ["All", "None"],
      commentsList: [],
      viewersList: ["All", "Departments", "Members"],
      addmembersdialog: false,
      addmembersList: [],
      selectedmembersview:[],
      approvalstatusbtn: false,
      statusbtn: true,
      statusRadioButton:'',
      approvalRadioButton: '',
      idFolder:"",
      profiledialog: false,
      teamMemberssearch:'',
      cat: [],
      bread: [
      {
        text: "My Projects",
        disabled: false,
        href: "/DashboardC",
        index: 1,
      },
      // Initial placeholder items for breadcrumb
      {
        text: null,
        disabled: false,
        href: null,
        index: 2,
      },
      {
        text: null,
        disabled: false,
        href: null,
        index: 3,
      }
    ],
      filterListleft: [
        { text: "Status", value: "status" },
        { text: "Approval Status", value: "approvalStatus" },
      ],
      filterListright: [
        {
          text: "Obsolete",
          value: "Obsolete",
        },
        {
          text: "Current",
          value: "Current",
        },
        {
          text: "Updating",
          value: "Updating",
        },
      ],
      menu: false,
      selectedFilter: null,
      formData: new FormData(),

      showAddDepartmentDialog: false,
      showAddMembersDialog: false,
      departmentSearch: '',
      memberSearch: '',
      departments: [],
      selectedDepartmentsTemp: [],
      selectedDepartments: [],
      selectedMembers: [],
      selectedMembersTemp: [],
      departmentsforpost: [],
      membersForPost: [],
      selectedmembers:'',
      departmentname:'',
      departmentName:'',
      depHead:'',
      editDepartmentDialog: false,
      deptname: this.$route.query.depName,
      did: this.$route.query.depId,
      dep:{},
      departmentHeadEdit:{},
      departmentHeadid:'',
      deptheadSearch:'',
      isExit:false,
      heads:{},
      viewmembersearch:'',
      exitDialog: false,
      commentsLength: '',
      selectedDeptHead:'',
      projectMembersList:[],
      selectedFlex: 'status',
      approversdialog: false,
      departmentsforapproval:[],
      approvalDeptSearch:'',
      approveMembers:[],
      chooseApproverDialog: false,
      approveMembersChoose:[],
      isApprovalCheck : false,
      approvalCompulsory:'',
      priorityList:[1,2,3],
      editApproverDialog: false,
      editphoto:'',
      editName:'',
      editDesignation:'',
      editFirm:'',
      editEmail:'',
      editApprovalCompulsory: false,
      editPriority:null,
      editmembId:'',
      altproName:"",
      altdepName:"",
      typeofDoc: [],
      References:[],
      documentData: [],
      sendFilterDialog: false,



      sendFilterDialog: false,
  
  sendFilterProject:[],
  sendFilterdepartments:[],
  sendFilterprojectRadio:'',
  sendFilterDeptRadio:'',
  sendfromDateMenu: false,
  sendfromDate:'',
  sendtoDateMenu: false,
  sendtoDate:'',
  statusSendFilter:['Current','Obsolete','Updating'],
  ApprovalstatusSendFilter:['Approved','To be approved'],
  issuedfor: ['Approval','Information','Review','Construction'],
  sendissuedforRadio:'',
  sendStatusRadio:'',
  sendApprovalStatusRadio:'',
  senddocTypeRadio:'',
  senddocRefRadio:'',
  tagsSendFilter:[],
  sendTagsRadio:'',
  selectedItem: null,

  projectOptions: true,
  departmentOptions: false,
  dateOptions: false,
  statusOptions: false,
  ApprovalstatusOptions: false,
  issuedforOptions: false,
  tagsOptions: false,
  typeofDoc:[],
  selectedRef:[],
  docTypeOptions: false,
  docRefOptions: false,
  currentPage: 1,
  itemsPerPage: 15,
  totalPages: 1,
  fileRegisterSearch: "",
  selectedZipFiles: [],
    };
  },

  watch:{
    fileRegisterSearch(){
      this.currentPage = 1;
      this.defaultid();
    }
  },

  computed: {
    paginatedNotifications() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.files.slice(start, end);
    },
  },

  mounted() {
    this.defaultid();
    // this.getProfileHeader();
    this.getProjects();
   
    // this.memberProjects();
    this.tagsList();
    this.sendRequests();
    this.documentTypes();
  },

    methods: {
        truncateText(text, maxLength) {
    if (text.length > maxLength) {
      return text.slice(0, maxLength) + "...";
    }
    return text;
  },

        defaultid() {
      axios({
        method: "GET",
        url: "/project/files/register",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          searchKeyword: this.fileRegisterSearch,
        }
       
      })
        .then((response) => {
          if (response.data.status == true) {
            // this.files = response.data.data;

            this.files = response.data.data.map(file => ({
  ...file,
  projectName: file.projectId && file.projectId.name ? file.projectId.name : "N/A",
  departmentName: file.departmentId && file.departmentId.name ? file.departmentId.name : "N/A"
}));
            this.totalPages = Math.ceil(this.files.length / this.itemsPerPage);

            // this.projectName = response.data.data.projectId.name;
            // this.departmentName = response.data.data.departmentId.name;

          } else {
            // this.memberdialog = true;

            this.msg = response.data.msg;

            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.error(err);
        });
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

        formatDateTime(dateTimeString) {
      const dateTime = new Date(dateTimeString);
      const dateOptions = { day: "2-digit", month: "2-digit", year: "numeric" };
      const timeOptions = { hour: "2-digit", minute: "2-digit" };
      const formattedDate = dateTime
        .toLocaleDateString("en-GB", dateOptions)
        .replace(/\//g, "-");
      const formattedTime = dateTime.toLocaleTimeString("en-US", timeOptions); // Use 'en-US' locale for AM/PM format
      return `${formattedDate} ${formattedTime}`;
    },
    formatSize(fileSize) {
      return (fileSize / (1024 * 1024)).toFixed(2);
    },

  navigateToSelectedFile(fileId, name) {
    this.$router.push({
      path: "/regDetailedView",
      query: {
        proId: this.$route.query.proId,
        depId: this.$route.query.depId,
        // folderId: this.$route.query.folderId, // Uncomment if needed
        fileId: fileId,
        proName: this.$route.query.proName,
        depName: this.$route.query.depName,
        folderName: this.$route.query.folderName,
        fileName: name,
      },

      

    
    });
  },
  projectOut(){
      this.projectOptions = true;
      this.departmentOptions = false;
      this.dateOptions = false;
      this.statusOptions = false;
      this.ApprovalstatusOptions = false;
      this.tagsOptions = false;
      this.issuedforOptions = false;
      this.docTypeOptions = false;
      this.docRefOptions = false;

    },
    departmentOut(){
      this.departmentOptions = true;
      this.projectOptions = false;
      this.dateOptions = false;
      this.statusOptions = false;
      this.ApprovalstatusOptions = false;
      this.tagsOptions = false;
      this.issuedforOptions = false;
      this.docTypeOptions = false;
      this.docRefOptions = false;

    },
    dateOut(){
      this.dateOptions = true;
      this.projectOptions = false;
      this.departmentOptions = false;
      this.statusOptions = false;
      this.ApprovalstatusOptions = false;
      this.tagsOptions = false;
      this.issuedforOptions = false;
      this.docTypeOptions = false;
      this.docRefOptions = false;
    },
    statusOut(){
      this.statusOptions = true;
      this.ApprovalstatusOptions = false;
      this.dateOptions = false;
      this.projectOptions = false;
      this.departmentOptions = false;
      this.tagsOptions = false;
      this.issuedforOptions = false;
      this.docTypeOptions = false;
      this.docRefOptions = false;
    },
    ApprovalstatusOut(){
      this.ApprovalstatusOptions = true;
      this.statusOptions = false;
      this.dateOptions = false;
      this.projectOptions = false;
      this.departmentOptions = false;
      this.tagsOptions = false;
      this.issuedforOptions = false;
      this.docTypeOptions = false;
      this.docRefOptions = false;
    },
    issuedForOut(){
      this.issuedforOptions = true;
      this.statusOptions = false;
      this.ApprovalstatusOptions = false;
      this.dateOptions = false;
      this.projectOptions = false;
      this.departmentOptions = false;
      this.tagsOptions = false;
      this.docTypeOptions = false;
      this.docRefOptions = false;
    },
    docTypeOut(){
      this.docTypeOptions = true;
      this.statusOptions = false;
      this.ApprovalstatusOptions = false;
      this.dateOptions = false;
      this.projectOptions = false;
      this.departmentOptions = false;
      this.tagsOptions = false;
      this.issuedforOptions = false;
      this.docRefOptions = false;
    },
    docRefOut(){
      this.docRefOptions = true;
      this.statusOptions = false;
      this.ApprovalstatusOptions = false;
      this.dateOptions = false;
      this.projectOptions = false;
      this.departmentOptions = false;
      this.tagsOptions = false;
      this.issuedforOptions = false
      this.docTypeOptions = false;
    },
    tagsOut(){
      this.tagsOptions = true;
      this.dateOptions = false;
      this.projectOptions = false;
      this.departmentOptions = false;
      this.statusOptions = false;
      this.ApprovalstatusOptions = false;
    },

    getProjects() {
    this.appLoading=true;
    axios({
      method: "GET",
      url: "/project/list",
      headers: {
        token: localStorage.getItem("token"),
      },
      params: {
        searchKeyword: this.projectSearch,
        // memberId: this.member._id,
      }
    })
      .then((response) => {
        if (response.data.status == true) {
          this.requestingProject = response.data.data.slice(0,3);
          this.sendFilterProject = response.data.data;
          this.receiveFilterProject = response.data.data;
         
          // this.msg = response.data.msg;
          // this.showSnackBar = true;
        } else {
          this.msg = response.data.msg;
          this.showSnackBar = true;
        }
      })
      .catch((err) => {
        this.ServerError = true;
        console.error(err);
      });
  },
  getDepartments(pid) {
    axios({
      method: "GET",
      url: "/project/department/list/v1",
      headers: {
        token: localStorage.getItem("token"),
      },
      params: {
        projectId: pid,
        searchKeyword : this.departmentSearch,
      },
    })
      .then((response) => {
        if (response.data.status == true) {
          this.requestingDepartment = response.data.data.slice(0,3);
          // this.name = response.data.data[0].projectName;
          // this.msg = response.data.msg;
          console.log(this.clickedCard)
          // this.showSnackBar = true;
        } else {
          this.msg = response.data.msg;
          this.showSnackBar = true;
        }
      })
      .catch((err) => {
        this.ServerError = true;
        console.error(err);
      });
  },
  departmentsforSendFilter(pid) {
    axios({
      method: "GET",
      url: "/project/department/list/v1",
      headers: {
        token: localStorage.getItem("token"),
      },
      params: {
        projectId: pid,
      },
    })
      .then((response) => {
        if (response.data.status == true) {
          this.sendFilterdepartments = response.data.data;
          // this.name = response.data.data[0].projectName;
          // this.msg = response.data.msg;
          console.log(this.clickedCard)
          // this.showSnackBar = true;
        } else {
          this.msg = response.data.msg;
          this.showSnackBar = true;
        }
      })
      .catch((err) => {
        this.ServerError = true;
        console.error(err);
      });
  },

  tagsList() {
      axios({
        method: "GET",
        url: "/request/tag/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {},
      })
        .then((response) => {
          if (response.data.status == true) {
            this.tagsSendFilter = response.data.data;
            this.tagsReceiveFilter = response.data.data;
            this.msg = response.data.msg;
            // this.showSnackBar = true;
          } else {
            // this.memberdialog = true;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.error(err);
        });
    },

    documentTypes() {
      axios({
        method: "GET",
        url: "/documentType/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
      .then((response) => {
        if (response.data.status) {
          // Store document types and complete document data
          this.typeofDoc = response.data.data.map((item) => item.type);
          this.documentData = response.data.data;
        } else {
          this.msg = response.data.msg;
          this.showSnackBar = true;
        }
      })
      .catch((err) => {
        this.ServerError = true;
        console.log(err);
      });
    },
    
    // Method to update references based on the selected document type
    updateReferences() {
      // Find the document that matches the selected document type
      const selectedDocument = this.documentData.find(
        (doc) => doc.type === this.senddocTypeRadio
      );

      // If a matching document is found, update the references
      if (selectedDocument) {
        this.selectedRef = selectedDocument.references || [];
      } else {
        this.selectedRef = []; // If no matching document, clear the references
      }
    },
  

    sendRequests() {
  this.appLoading = true;
  axios({
      method: "GET",
      url: "/project/files/register",
      headers: {
        token: localStorage.getItem("token"),
      },
      params:{
        projectId: this.sendFilterprojectRadio,
        departmentId: this.sendFilterDeptRadio,
        fromDate: this.sendfromDate,
        toDate: this.sendtoDate,
        status: this.sendStatusRadio,
        approvalStatus: this.sendApprovalStatusRadio,
        issuedFor: this.sendissuedforRadio,
        documentType: this.senddocTypeRadio,
        documentReference: this.senddocRefRadio,
        tags: this.sendTagsRadio,
      },
  })
  .then((response) => {
      if (response.data.status == true) {
        //   this.requests = response.data.data;
          this.sendFilterDialog = false;
        //   this.tags= response.data.data.tags;
        //   this.requestId = response.data.data.map(item => item._id);
        //   if (this.requests.length > 0) {
    //   this.requestDetails(this.requests[0]._id);
    this.files = response.data.data;
        // this.defaultid();
    // }
    this.appLoading = false;
          // this.msg = response.data.msg;
          // this.showSnackBar = true;
      } else {
          // this.memberdialog = true;
          this.msg = response.data.msg;
          this.showSnackBar = true;
          this.appLoading = false;
      }
  })
  .catch((err) => {
      this.ServerError = true;
      console.error(err);
      this.appLoading = false;
  });
},

// requestDetails(id) {
// this.requestIdVariable = id;
//   axios({
//       method: "GET",
//       url: '/request/view/' + id,
//       headers: {
//         token: localStorage.getItem("token"),
//       },
//       params:{
        
//       },
//   })
//   .then((response) => {
//       if (response.data.status == true) {
//           this.reqDetails = response.data.data;
//           this.tags= response.data.data.tags;
//           this.trackStatus = response.data.data.trackStatus;
//           if(this.Flag){
//             this.reOpen = false;
//             this.submitbtn = false;
//             this.reOpenbtn = true;
//             this.reason = "";
//           }
//           // this.msg = response.data.msg;
//           // this.showSnackBar = true;
//       } else {
//           // this.memberdialog = true;
//           this.msg = response.data.msg;
//           this.showSnackBar = true;
//       }
//   })
//   .catch((err) => {
//       this.ServerError = true;
//       console.error(err);
//   });
// },

    clearSendRequestFilter(){
      this.sendFilterprojectRadio = '';
      this.sendFilterDeptRadio = '';
      this.sendStatusRadio = '';
      this.sendApprovalStatusRadio = '';
      this.sendissuedforRadio = '';
      this.sendTagsRadio = '';
      this.sendfromDate = '';
      this.sendtoDate = '';
      this.sendissuedforRadio = '',
      this.senddocTypeRadio = '',
      this.senddocRefRadio = '',
      this.sendRequests();
    },

    fileExportZip() {
  if (this.selectedZipFiles.length === 0) {
    this.$toast.error("Please select at least one file."); // Add error handling for empty selection
    return;
  }

  axios({
    method: "POST",
    url: "/project/file/export/zip",
    headers: {
      token: localStorage.getItem("token"),
    },
    data: {
      fileIds: this.selectedZipFiles, // Pass the array of selected file IDs
    },
    responseType: "blob", // Set the response type to 'blob'
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Files_List.zip"); // Adjust the filename as needed
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.selectedZipFiles = [];
    })
    .catch((err) => {
      this.$toast.error("Failed to download files. Please try again."); // Snackbar for errors
      console.log(err);
    });
},

fileExportXlsx(id) {
  axios({
    method: "GET",
    url: "/project/files/export",
    headers: {
      token: localStorage.getItem("token"),
    },
    params: {
      projectId: this.sendFilterprojectRadio,
        departmentId: this.sendFilterDeptRadio,
        fromDate: this.sendfromDate,
        toDate: this.sendtoDate,
        status: this.sendStatusRadio,
        approvalStatus: this.sendApprovalStatusRadio,
        issuedFor: this.sendissuedforRadio,
        documentType: this.senddocTypeRadio,
        documentReference: this.senddocRefRadio,
        tags: this.sendTagsRadio,
    },
    responseType: "blob",  // Important to set the response type to 'blob'
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Files_List.xlsx"); // Change the file name if needed
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch((err) => {
      this.appLoading = false;
      this.ServerError = true;
      console.log(err);
    });
},


}
    }

</script>

<style scoped>
.selected-flex {
  border-left: 4px solid green;
}

.scrollable-container {
  max-height: 400px; /* Set the height you need */
  overflow-y: auto;
}
.custom-radio-group {
  padding: 0;
  margin: 0;
}

.custom-radio {
  padding: 0 !important;
  margin: 0 !important;
}
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45vh; /* Full viewport height */
}
.custom-card-yellow {
border-left: 4px solid #f0ab00; /* Blue border */
}

.custom-card-blue {
border-left: 4px solid #2b9af3; /* Green border */
}

.custom-card-red {
border-left: 4px solid rgba(228, 25, 25, 1) /* Green border */
}

.custom-card-def {
border-left: 4px solid #3e8635 /* Green border */
}
.custom-card-teal {
border-left: 4px solid #73c5c5 /* Green border */
}
.custom-border {
border: 2px solid rgba(227, 227, 227, 1);
border-radius: 10px /* Adjust thickness and color as needed */
}
</style>